import React, { useState, useEffect, useContext, useRef } from "react";
import "./Stock.css";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import QRCode from "react-qr-code";

import DropDown from "../../Components/DropDown/DropDown";
import Modal from "../../Components/Modal/Modal";
import Input from "../../Components/Input/Input";
import Message from "../../Components/Message/Message";
import ViewStockModal from "../../Components/ViewStockModal/ViewStockModal";
import AuthContext from "../../context/Services/Auth";
import { useTranslation } from "react-i18next";

import { MdDeleteOutline, MdDriveFileRenameOutline } from "react-icons/md";
import { AiOutlineEdit } from "react-icons/ai";
import { FaEye, FaImages } from "react-icons/fa";
import { BsFilterLeft } from "react-icons/bs";
import { IoMdArrowDropdown, IoMdAdd } from "react-icons/io";
import { LuCheck } from "react-icons/lu";
import { GoNumber } from "react-icons/go";
import { MdPhotoSizeSelectLarge } from "react-icons/md";
import { IoIosSearch } from "react-icons/io";
import { HiQrcode } from "react-icons/hi";

import {
  get_all_stock,
  delete_stock,
  confirm_product,
} from "../../context/Services/Stock";
import { get_config, get_all_categories } from "../../context/Services/Settings";

const Stock = () => {
  const { t } = useTranslation();
  const { userData } = useContext(AuthContext);
  const navigate = useNavigate();
  const qrRef = useRef();

  const [query, setQuery] = useState("");
  const [showFiler, setShowFilter] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showStock, setShowStock] = useState({
    status: false,
    stock_id: null,
  });

  const intial_payload = {
    stock_id: null,
    distination: "",
    adresse: "",
    buyer: "",
    sell_price: "",
    buyer_phone: "",
    quantity_declared: 0,
    note: "",
    confirmation_details: [],
  };
  const [payload, setPayload] = useState(intial_payload);

  const initial_search_payload = {
    category: null,
    sub_category: null,
    query: "",
  };
  const [searchPayload, setSearchPayload] = useState(initial_search_payload);

  const [products, setProducts] = useState([]);
  const [status, setStatus] = useState(false);
  const [loading, setLoading] = useState(true);

  // Categories state
  const [categories, setCategories] = useState([]);

  const [productConfig, setProductConfig] = useState(null);
  const [config, setConfig] = useState({
    SIZES: [],
    COLORS: [],
    CATEGORIES: [],
    STATUSES: [],
    SUBCATEGORY: [],
  });

  const [settings, setSettings] = useState({
    count: 1,
    data: {},
  });

  const add_setting = (index, elem, value, stock_id) => {
    let check_exists = settings?.data[`${index}`];

    if (check_exists) {
      setSettings((prev) => ({
        ...prev,
        data: {
          ...prev.data,
          [`${index}`]: { ...prev.data[`${index}`], quantity: value },
        },
      }));
    } else {
      setSettings((prev) => ({
        ...prev,
        data: {
          ...prev.data,
          [`${index}`]: { ...elem, quantity: value, stock_id: stock_id },
        },
      }));
    }
  };

  const handle_get_stock = (is_filtered) => {
    get_all_stock(searchPayload)
      .then((res) => {
        setProducts(res?.data);
        setLoading(false);

        if (is_filtered) {
          setShowFilter(false);
        }
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);

        if (is_filtered) {
          setShowFilter(false);
        }
      });
  };

  const handle_get_categories = () => {
    get_all_categories()
      .then((res) => {
        setCategories(res?.data || []);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handle_delete_stock = async (id) => {
    const willDelete = await swal({
      title: "Es-vous sûr ?",
      text: t("Est ce que vous voulez vraiment supprimer ?"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (willDelete) {
      delete_stock(id)
        .then((res) => {
          handle_get_stock();
          setTimeout(() => {
            setStatus(false);
          }, 1500);
        })
        .catch((e) => setStatus(false));
    }
  };

  const handle_confirmation = () => {
    setStatus(true);
    confirm_product({
      ...payload,
      confirmation_details: Object.values(settings?.data),
    })
      .then((res) => {
        handle_get_stock();
        setTimeout(() => {
          setPayload(intial_payload);
          setSettings({
            count: 1,
            data: {},
          });
          setStatus(false);
        }, 1500);
        setShowConfirm(false);
      })
      .catch((e) => {
        console.log(e);
        setStatus(true);
      });
  };

  const handle_setup_confirmation = (elem) => {
    setShowConfirm(true);
    setPayload((prev) => ({ ...prev, stock_id: elem?._id }));
    setProductConfig(elem);
  };

  const handle_navigate_stock = (id, action) => {
    navigate(`/stock/${id}?action=${action}`);
  };

  // QR Code generation and download
  const generateAndDownload = (id) => {
    const tempContainer = document.createElement("div");
    tempContainer.style.position = "absolute";
    tempContainer.style.left = "-9999px";
    document.body.appendChild(tempContainer);

    const tempQRCode = (
      <div ref={qrRef}>
        <QRCode value={id} />
      </div>
    );

    import("react-dom").then((ReactDOM) => {
      ReactDOM.render(tempQRCode, tempContainer, () => {
        const svg = tempContainer.querySelector("svg");
        const svgData = new XMLSerializer().serializeToString(svg);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const img = new Image();
        const svgBlob = new Blob([svgData], {
          type: "image/svg+xml;charset=utf-8",
        });
        const url = URL.createObjectURL(svgBlob);

        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          URL.revokeObjectURL(url);

          const pngUrl = canvas.toDataURL("image/png");
          const downloadLink = document.createElement("a");
          downloadLink.href = pngUrl;
          downloadLink.download = `stock-qr-${id}.png`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          document.body.removeChild(tempContainer);
        };

        img.src = url;
      });
    });
  };

  const handle_select_characteristics = (field, value) => {
    let check_has_value = payload[field].includes(value);

    if (check_has_value) {
      let filter_out = payload[field].filter((elem) => elem !== value);
      setPayload((prev) => ({ ...prev, [field]: filter_out }));
    } else {
      setPayload((prev) => ({ ...prev, [field]: [...prev[field], value] }));
    }
  };

  const handle_get_config = () => {
    get_config("all")
      .then((res) => {
        setConfig(res?.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleCategoryChange = (categoryId) => {
    setSearchPayload((prev) => ({ ...prev, category: categoryId }));
  };

  useEffect(() => {
    setLoading(true);
    handle_get_config();
    handle_get_categories();
  }, []);

  useEffect(() => {
    handle_get_stock();
  }, [searchPayload.query, searchPayload.category]);

  return (
    <>
      <Message loading={status} status={{ status: status }} />

      <div className="clients_overview latest_clients_overview shadow">
        <div className="chart_section_header flex items-center">
          <b>{t("Stock Overview")}</b>
          <div className="relative to-right flex gap">
            {userData?.role === "admin" && (
              <div
                className="flex gap items-center filter_button"
                onClick={() => navigate("/add_stock")}
              >
                <IoMdAdd style={{ color: "#7983ff", fontSize: "1.2rem" }} />
                <b>{t("Ajouter stock")}</b>
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col gap summary_clients_section">
          <div className="flex stock_head">
            <div className="flex gap total_div  ml_15 mt_-10">
              <p>{t("Total Value")}</p>
              <b>
                {products?.total_stock_mad} {t("MAD")}
              </b>
            </div>

            <div className="flex gap search_section">
              {/* Category Filter */}
              <div className="relative">
                <DropDown
                  customButtonStyle="justify-start category_dropdown"
                  button={
                    <>
                      <BsFilterLeft />
                      <b>
                        {searchPayload.category
                          ? categories.find((cat) => cat._id === searchPayload.category)?.value || t("Toutes les catégories")
                          : t("Toutes les catégories")}
                      </b>
                      <IoMdArrowDropdown />
                    </>
                  }
                >
                  <div
                    className="drop_item"
                    onClick={() => handleCategoryChange(null)}
                  >
                    {t("Toutes les catégories")}
                  </div>
                  {categories.map((cat) => (
                    <div
                      key={cat._id}
                      className="drop_item"
                      onClick={() => handleCategoryChange(cat._id)}
                    >
                      {cat.value}
                    </div>
                  ))}
                </DropDown>
              </div>

              <Input
                placeholder="Search"
                setChange={(e) =>
                  setSearchPayload((prev) => ({ ...prev, query: e }))
                }
                value={searchPayload.query}
                customInputStyle="search_input_edited"
                customParentStyle="parent_search_input_edited"
              />
            </div>
          </div>
          <div className="table_section table_section_overwrite">
            <table cellPadding="0" cellSpacing="0">
              <tbody>
                <tr>
                  <td className="table-keys cell2 pointer">
                    {t("Image de produit")}
                  </td>
                  <td className="table-keys cell2 pointer">
                    {t("Product Name")}
                  </td>
                  <td className="table-keys cell2 pointer">{t("Type")}</td>
                  <td className="table-keys cell2 pointer">{t("Catégorie")}</td>
                  <td className="table-keys cell2 pointer">{t("Quantity")}</td>
                  <td className="table-keys cell2 pointer">{t("P. d'achat")}</td>
                  {userData?.role === "admin" && (
                    <td className="table-keys cell2 pointer">{t("Prix de vente")}</td>
                  )}
                  <td className="table-keys cell2 pointer">{t("Note")}</td>
                  <td className="table-keys cell2 pointer">{t("Action")}</td>
                </tr>

                {products?.stock?.map((elem, i) => (
                  <tr className={`data-cells`} key={i}>
                    <td className={`value2 cell2  `}>
                      <div className="pointer flex items-center justify-center">
                        {elem?.principal_image || elem?.image_path ? (
                          <img
                            src={elem?.principal_image || elem?.image_path}
                            className="user_img product_img"
                          />
                        ) : (
                          <div className="user_img product_img flex items-center justify-center" style={{ backgroundColor: '#f0f0f0', borderRadius: '8px' }}>
                            <FaImages style={{ fontSize: '1.2rem', color: '#ccc' }} />
                          </div>
                        )}
                      </div>
                    </td>
                    <td className={`value2 cell2  `}>{elem?.product_name}</td>
                    <td className={`value2 cell2  `}>{elem?.type || "-"}</td>
                    <td className={`value2 cell2  `}>
                      {elem?.categories && elem.categories.length > 0 ? (
                        <div className="flex items-center gap_5">
                          <span
                            style={{
                              backgroundColor: elem.categories[0].bg_color,
                              color: elem.categories[0].text_color,
                              padding: "4px 8px",
                              borderRadius: "4px",
                              fontSize: "12px"
                            }}
                          >
                            {elem.categories[0].value}
                          </span>
                          {elem.categories.length > 1 && (
                            <span
                              style={{
                                backgroundColor: "#f0f0f0",
                                color: "#666",
                                padding: "4px 6px",
                                borderRadius: "4px",
                                fontSize: "11px"
                              }}
                            >
                              +{elem.categories.length - 1}
                            </span>
                          )}
                        </div>
                      ) : "-"}
                    </td>
                    <td className={`value2 cell2  `}>{elem?.quantity}</td>
                    <td className={`value2 cell2  `}>
                      {elem?.buy_price} {t("MAD")}
                    </td>
                    {userData?.role === "admin" && (
                      <td className={`value2 cell2  `}>
                        {elem?.prix_de_vente || 0} {t("MAD")}
                      </td>
                    )}
                    <td className={`value2 cell2  `}>
                      {elem?.product_note === "" ? "-" : elem?.product_note}
                    </td>
                    <td className={`value2 cell2 action`}>
                      <div className="flex gap_5 justify-center">
                        <HiQrcode
                          className="action_btn"
                          style={{ backgroundColor: "grey" }}
                          onClick={() => generateAndDownload(elem?._id)}
                          title={t("Download QR Code")}
                        />
                        <FaEye
                          className="action_btn view"
                          onClick={() =>
                            handle_navigate_stock(elem?._id, "readonly")
                          }
                        />
                        {userData?.role === "admin" && (
                          <>
                            <MdDeleteOutline
                              className="action_btn delete"
                              onClick={() => handle_delete_stock(elem?._id)}
                            />
                            <AiOutlineEdit
                              className="action_btn edit"
                              onClick={() =>
                                handle_navigate_stock(elem?._id, "write")
                              }
                            />
                          </>
                        )}
                        <LuCheck
                          className="action_btn confirm"
                          onClick={() => handle_setup_confirmation(elem)}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Stock;
